import styled, { css } from 'styled-components'

import { fontWeight, color, size } from 'ui/themes/utils'

import I from 'ui/elements/I'

export const Collection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 14px !important;
  line-height: 32px !important;
  font-family: "Roboto", sans-serif;

  cursor: pointer;

  font-weight: ${fontWeight('normal')} !important;

  clear: both;

  ${({ active }) => active && css`
    font-weight: ${fontWeight('bold')} !important;
  `}

  > div {
    flex-grow: 1;
    text-align: left;
  }

  > span {
    color: ${color('Text/Secondary')};
    font-weight: ${fontWeight('normal')} !important;
  }

  > ${I} {
    padding-right: ${size('padding', 'md')};
  }
`

export const CollectionList = styled.ul`
  ${({ noPadding }) => !noPadding && css`
    > li {
      padding-left: 10px;
    }
  `}
`
